import { useContext } from 'react'
import { components } from '@digital-commerce/shared-utils'
import { string, object, bool } from 'prop-types'

import { Notification, Typography, Link, Spacer } from '@telus-uds/components-web'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import useCart from '../../../hooks/useCart'
import { isOutOfStock } from '../../../utils/rti'
import { consumer, business, outOfStockError } from './constants'

const { ShouldRender } = components

const ItemOutOfStock = ({ changeUrl, category, device, noCta, isBusinessCart = false }) => {
  const { lang } = useContext(localeContext)
  const { removeItems } = useCart()

  const translate = useTranslate()
  const t = (path) => translate(`itemOutOfStock.${path}`)

  if (!isOutOfStock(device)) return null

  const _getCatalogUrl = () => {
    const urlMap = isBusinessCart ? business : consumer

    if (!(category in urlMap)) return null
    return urlMap[category]
  }

  const catalogUrl = _getCatalogUrl()

  const catalogCopy = `${t('catalogCta')} ${t(`category.${category}`)}`

  const handleClick = (e) => {
    e.preventDefault()
    removeItems({
      items: [device],
      postRemoval: () => window.location.assign(catalogUrl)
    })
  }

  return (
    <>
      <Notification variant="error" copy={lang} role="alert">
        <Typography variant={{ bold: true }}>{t('warning')} </Typography>
        <ShouldRender when={changeUrl && !noCta}>
          <Link href={`${changeUrl + outOfStockError}`} variant={{ style: 'inline' }}>
            {t('editCta')}
          </Link>
          <Typography>{t('conjunction')}</Typography>
        </ShouldRender>
        <ShouldRender when={catalogUrl && !noCta}>
          <Link href={catalogUrl} onClick={handleClick} variant={{ style: 'inline' }}>
            {changeUrl ? catalogCopy.toLowerCase() : catalogCopy}
          </Link>
        </ShouldRender>
      </Notification>
      <Spacer space={5} />
    </>
  )
}

export default ItemOutOfStock

ItemOutOfStock.propTypes = {
  changeUrl: string,
  category: string.isRequired,
  device: object.isRequired,
  noCta: bool,
  isBusinessCart: bool
}

ItemOutOfStock.defaultProps = {
  changeUrl: null,
  noCta: false,
  isBusinessCart: false
}
